import { render, staticRenderFns } from "./default.vue?vue&type=template&id=ded8b314"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=ded8b314&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Header.vue').default,Wmkc: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Wmkc.vue').default,Footer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Footer.vue').default})
